import { Footer } from '@ta-interaktiv/react-footer'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/rail.css'
import './App.css'
import React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { Masthead } from '@ta-interaktiv/react-masthead'
import Profile from '../../components/profile'
import Answer from '../../components/answer'
import Question from '../../components/question'
import FollowUp from '../../components/followup'
// import Tracking from 'ta-react-polymorphic-tracking';
// import StandaloneShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons';
// import CopyrightNotice from 'ta-react-polymorphic-copyright-notice';
import { Waypoint } from 'react-waypoint'
const ARTICLE_ID = '757220345949'
export class AppComponent extends React.Component {
  constructor(props) {
    super(props)

    this.domain = parseHostname().publicationDomain
  }

  render() {
    return (
      <div className='index'>
        <Masthead
          inverted
          articleId={ARTICLE_ID}
          additionalFacebookShares={191}
        />

        <header
          className='ui inverted block vertical segment'
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.5)), url(${require('./header.jpg')})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            height: '100vh'
          }}
        >
          <div className='ui container'>
            <div className='header block'>
              <div className='ui container'>
                <h1 className='ui huge white header'>Fünf Männer über Sex</h1>
                <p className='ta lead'>
                  Ein Gespräch über Tantra, Orgasmusjagden und offene
                  Beziehungen.
                </p>
              </div>
            </div>
          </div>
        </header>

        <figcaption className='ui container ta caption'>
          Kurz vor dem Höhepunkt: Die Serie «Cumfaces» von Fotograf Stuart
          Sanford zeigt Männer unmittelbar vor dem Orgasmus.
        </figcaption>

        <main className=''>
          <section className='ui vertical segment'>
            <div className='ui text container'>
              <p className='ta lead'>
                <div className='ta author'>
                  Von Martin Sturzenegger und Christian Zürcher
                </div>
              </p>
              <p className='ta lead'>
                Knapp vier Stunden sind vorbei, das Interview ist beendet – und
                doch sprechen die fünf Männer weiter. Über Sex. Das Thema
                beschäftigt, inspiriert und verärgert. Die Männer zeigen sich
                überrascht, dass es gemeinhin heisst, die männliche Sexualität
                sei weniger komplex als jene der Frau.
              </p>
              <p className='ta lead'>
                Vor 8 Wochen haben &nbsp;
                <a href='http://interaktiv.tagesanzeiger.ch/2017/sechs-frauen/?nosome'>
                  sechs Frauen über ihre sexuellen Erfahrungen berichtet
                </a>
                . Nun machen es fünf Männer, alle über 30. Sie blicken zurück
                und erzählen von ihren Fantasien und Ängsten.
              </p>

              <Waypoint
                scrollableAncestor={window}
                onEnter={event => {
                  if (event.previousPosition === 'below') {
                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                      event: 'startReading'
                    })
                  }
                }}
              />
            </div>
          </section>

          <aside className='ui vertical blue fitted segment'>
            <div className='ui container'>
              <div className='ui relaxed two column stackable grid'>
                <div className='column'>
                  <Profile
                    avatarSrc={require('./avatar-6.svg')}
                    name='Nicolas*, 42, Selbstständiger Werber'
                  >
                    Lebte früher ein ausschweifendes Party- und Sexleben. Hatte
                    irgendwann genug vom Exzess und fand zu Gott. Mit seiner
                    inzwischen verstorbenen Ehefrau befolgte er das Gebot: Kein
                    Sex vor der Ehe.
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    avatarSrc={require('./avatar-4.svg')}
                    name='Silvan, 33, Mitarbeiter Kommunikation'
                  >
                    Seit einem Jahr in fester Beziehung. Seit er 13 ist, lebte
                    er stets in Langzeitbeziehungen – mit kurzen Unterbrüchen.
                    Nichts erregt ihn mehr als die Lust einer Frau.
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Nino, 42, Ingenieur'
                    avatarSrc={require('./avatar-5.svg')}
                  >
                    Wanderte als junger Erwachsener in die Schweiz ein. Führte
                    mehrere längere Beziehungen, war verheiratet und hat Kinder.
                    Verspürt zurzeit keine Lust auf Beziehungen. Verkehrt
                    gelegentlich im Rotlichtmilieu.
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Beat, 35, Künstler'
                    avatarSrc={require('./avatar-2.svg')}
                  >
                    Ist seit ein paar Jahren Single, datet regelmässig.
                    Bezeichnet sich selbst als «Orgasmusjäger», verehrt den
                    weiblichen Körper und sieht es als seine Pflicht, die Frau
                    zum Höhepunkt zu bringen.
                  </Profile>
                </div>

                <div className='column'>
                  <Profile
                    name='Pascal, 30, Tantra-Masseur'
                    avatarSrc={require('./avatar-1.svg')}
                  >
                    {' '}
                    Lebt mit seiner Frau in einer offenen Beziehung und erwartet
                    mit ihr ein Kind. Hat soeben eine Praxis für Tantra-Massagen
                    eröffnet. Glaubt, dass Männer sexuell ebenso komplex sind
                    wie Frauen.
                  </Profile>
                </div>
              </div>
              <div className='ui one column grid'>
                <div className='column'>
                  <small>* Alle Namen wurden geändert.</small>
                </div>
              </div>
            </div>
          </aside>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Hat sich die Bedeutung von Sex im Laufe der Jahre verändert?'
                classes='ui small blue header'
              >
                <Answer who='Nino'>
                  <p>
                    Nein, er ist einer der wenigen Konstanten in meinem Leben.
                    Sex ist für mich wie Essen oder Schlafen – eine
                    Notwendigkeit. Ohne Sex geht es mir schlecht.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Mir geht es wie dir: Sex gehört für mich zum täglichen Brot.
                    Habe ich keinen Geschlechtsverkehr, dann muss ich onanieren.
                    Früher war das anders: Ich war ein Spätzünder, mein erstes
                    Mal war mit 19. Damals war meine Vorstellung vom
                    eigentlichen Akt an sich viel romantischer, als sie dies
                    heute ist. Oft schüttelte ich den Kopf, wenn ich auf der
                    Strasse gestandene Männer sah, deren Blicke auch dann noch
                    die weiblichen Kurven fixierten, wenn sie längst bemerkt
                    wurden.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Bei mir hat sich der Sex massiv verändert. Ich erlebte mein
                    erstes Mal mit 14, es folgte eine Zeit des Experimentierens.
                    Alles war neu und aufregend, aber immer nur Sex im
                    klassischen Sinne. In den letzten Jahren öffnete sich mir
                    eine neue Welt: Die Tantra-Massage ist ein wichtiger Teil
                    davon.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Es war ein Auf und Ab. In jungen Jahren hatte ich lange eine
                    feste Freundin. Dann kam die Zeit der Partys und Drogen. Ich
                    liess mich gehen, hatte viele Sexpartnerinnen. Mit der Zeit
                    merkte ich, dass es mich nicht befriedigt, Frauen als
                    Objekte zu jagen. Ich wollte Persönlichkeiten kennen lernen.
                    Eines Tages entschied ich mich, zwischen den Beziehungen
                    enthaltsam zu leben.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Sex hatte für mich nie erste Priorität. Die Beziehung steht
                    immer im Vordergrund. Die sexuelle Häufigkeit und die
                    Qualität sind abhängig von der menschlichen Kombination, dem
                    Zustand der Beziehung.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Wie wichtig ist euch der Orgasmus?'
                classes='ui small blue header'
              >
                {' '}
                <Answer who='Nicolas'>
                  <p>
                    Sehr wichtig. Die Reise der Liebe endet für mich mit dem
                    Orgasmus.
                  </p>
                </Answer>{' '}
                <Answer who='Nino'>
                  <p>
                    Für mich ist er zweitrangig. Man muss nicht kommen, um einen
                    Orgasmus zu erleben. Das schönste Gefühl entsteht für mich
                    während des Akts. Wenn es im Bett harmoniert, dann gibt es
                    diverse orgasmische Zustände. Diese zu erreichen, ist für
                    mich das höchste Ziel beim Sex. Anders ist es für mich, wenn
                    ich zu einer Prostituierten gehe. Dann ist der Orgasmus das
                    Wichtigste, das Decken eines Grundbedürfnisses. Ich gehe ins
                    Bordell, wie ich zum Essen ins Restaurant gehe.
                  </p>
                </Answer>{' '}
                <Answer who='Pascal'>
                  <p>
                    Der Orgasmus beschränkt sich bei mir nicht auf die
                    Ejakulation. Mich nervt dieses Klischee: Die Sexualität der
                    Männer sei simpel und nur auf den Endpunkt bedacht, jene der
                    Frau hingegen viel komplexer. Was für ein Irrsinn! Die
                    Sexualität der Männer ist genauso komplex. Das klischierte
                    Rollendenken findet sich auch in der Pornoindustrie wider.
                    Der Mann wird zum Orgasmusjäger degradiert. Doch genau diese
                    Orgasmusfixiertheit hindert uns am Entdecken der eigenen
                    Sexualität.
                  </p>
                </Answer>{' '}
                <Answer who='Beat'>
                  <p>
                    Ich gestehe: Hauptziel ist für mich der Orgasmus. Doch der
                    Weg dahin ist unglaublich faszinierend. Das beginnt beim
                    Kennenlernen, beim ersten Knistern. Liegt eine schöne Frau
                    in meinem Bett, dann begehre ich ihren Körper. Nicht nur
                    sexuell, sondern als Betrachter: Zentimeter für Zentimeter.
                    Eine Anmut, die für mich fast göttlichen Charakter besitzt.
                  </p>
                </Answer>{' '}
              </Question>

              <Question
                q='Wie wichtig ist euch, dass die Partnerin zum Orgasmus kommt?'
                classes='ui small blue header'
              >
                <Answer who='Beat'>
                  <p>
                    Ich sehe es als meine Pflicht. Einer meiner ersten Pornos
                    war ein Tutorial darüber, wie man eine Frau zum Orgasmus
                    bringt. Das hatte ich damals sehr ernst genommen und nehme
                    es immer noch ernst. Doch es klappt nicht immer, und der
                    Partnerin kann bisweilen die Lust vergehen, wenn sie merkt,
                    dass diesbezüglich eine Erwartung da ist.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Es kommt auf den Kontext an. Wenn ich mit meiner Partnerin
                    Zeit habe, dann unbedingt! Kommt es zur schnellen Nummer an
                    einem einsamen Plätzchen in der Natur, dann steht das
                    Abenteuer im Vordergrund – beides kann schön sein.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Ich verhalte mich wie ein Gentleman – aber nur, wenn sie
                    auch etwas zurückgibt. Ich hatte schon Sexpartnerinnen, die
                    benutzten mich dazu, um selbst zum Orgasmus zu kommen. Es
                    war kein Zusammenspiel. Sie hatte mich flachgelegt, meinen
                    Körper für egoistische Zwecke verwendet. Da vergeht mir die
                    Lust.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>Machst du nicht das Gleiche mit den Prostituierten?</p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Dort ist das Verhältnis professionell, was beiden klar ist.
                    Ich behandle auch diese Frauen zuvorkommend. Aber es ist
                    klar, dass ich dort für die schnelle Befriedigung hingehe.
                    Dafür bezahle ich Geld. Diese Frauen verlangen ja auch
                    nichts weiter von mir. Lerne ich eine Frau im Ausgang oder
                    im Alltag kennen, dann gelten für mich andere Massstäbe.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Erinnert ihr euch an euren ersten Orgasmus?'
                classes='ui small blue header'
              >
                <Answer who='Beat'>
                  <p>
                    Es geschah, als ich 13 war. Mithilfe eines Massagegeräts,
                    das der Mutter eines Freundes gehörte. Der Kollege zeigte es
                    vor und behielt dabei die Hosen an. Plötzlich zog er die
                    Füsse an und zitterte am ganzen Leib. Ich dachte: «Wow», und
                    probierte es auch. Ohne zu wissen, was wir überhaupt taten.
                    Als ich kam, dachte ich, ich müsse sterben. Ich sah nichts
                    mehr, der ganze Körper zitterte. Es war wie eine Droge, nie
                    mehr danach war ein Orgasmus intensiver.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Auch ich onanierte zuerst unter Anleitung eines Kollegen. Es
                    war gegen Ende der Primarschulzeit. Er sagte mir, dass er
                    dabei an weibliche Brüste denke. Das fand ich äusserst
                    grotesk. Denn Brüste hatte ich bis anhin nicht mit Sex in
                    Verbindung gebracht. Etwa ein Jahr später, als ich zum
                    ersten Mal einen Softporno sah, begriff ich, was er meinte.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Ich versammelte mich Ende sechster Klasse mit Kollegen.
                    Derjenige, der am weitesten entwickelt war, sagte: «Schaut
                    her, was ich mit meinem Penis kann.» Wir waren sehr
                    beeindruckt und imitierten ihn. Es war ein rein technischer
                    Vorgang und hatte nichts Sinnliches.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Der sexuelle Pionier aus meiner Primarschulzeit stammte aus
                    Ex-Jugoslawien und war körperlich schon weiter entwickelt
                    als wir. Unter der Dusche des Schwimmunterrichts prahlte er
                    mit seinem grossen Genital. Wir waren beeindruckt und
                    schreckten nicht davor zurück, seinen Penis anzufassen. Das
                    hatte nichts Homoerotisches, sondern geschah aus reiner
                    Neugier.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Was bedeutet euch das Masturbieren?'
                classes='ui small blue header'
              >
                <Answer who='Nino'>
                  <p>
                    Ich mache es täglich als Abendritual. Nach dem Yoga hole ich
                    mir einen runter, dann kann ich besser einschlafen.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Und wenn du am nächsten Tag eine Frau triffst? Versuchst du
                    dann deine Geilheit nicht aufzusparen?
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Das sind für mich zwei verschiedene Sexwelten, die parallel
                    zueinander existieren. Das eine schliesst das andere nicht
                    aus.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Ich sehe das auch so: Masturbieren und Sex haben wenig
                    gemeinsam. Ich masturbiere auch, wenn ich Sex habe. Nur wenn
                    ich gestresst bin, mache ich es seltener.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Bei mir ist es genau umgekehrt. Bin ich gestresst, dann lege
                    ich schneller Hand an. Sonst sicher täglich.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Ich onaniere auch häufig in Stressphasen. Dann baue ich
                    physischen Druck ab. Es gibt mir keine wirkliche
                    Befriedigung, aber ich fühle mich danach entspannter.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <figure className='ui vertical very fitted segment'>
            <img
              src={require('./mann2.jpg')}
              alt=''
              className='ui fluid block image'
            />
            <div className='ui container'>
              <figcaption className='ta caption'>
                12 Männer folgten dem Aufruf des Londoner Künstlers und
                lichteten sich selber beim Erreichen des Orgasmus ab.
              </figcaption>
            </div>
          </figure>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question
                q='Schaut ihr Pornos, oder gebt ihr eurer Fantasie auch mal eine Chance?'
                classes='ui small blue header'
              >
                <Answer who='Pascal'>
                  <p>
                    Früher habe ich nur zu Pornos onaniert. Inzwischen habe ich
                    gelernt, meine Fantasie wieder zu gebrauchen. Ich entdecke
                    dabei auch meinen eigenen Körper neu. Für mich muss die
                    eigene Sexualität auch in der Beziehung Platz haben. Meine
                    Frau und ich reden über unsere sexuellen Erlebnisse mit uns
                    selbst und freuen uns füreinander. Für mich heisst onanieren
                    nicht, verschämt vor dem Computer zu sitzen.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Ich konsumiere Pornos. Jedoch meistens nicht für den
                    schnellen Kick. Meist spule ich an den Schluss, weil es mich
                    interessiert, wie es endet. Wenn sie schluckt, macht mich
                    das extrem an, dann gehe ich an den Anfang und schaue mir
                    den Porno an. Ich sehe gerne Filme, die eine Geschichte
                    erzählen: Eine Frau, die den Hausarzt besucht etwa. Vielfach
                    schaue ich den ganzen Film zu Ende, was durchaus 20 Minuten
                    oder länger dauern kann. Vermutlich dienen diese
                    Spannungsbögen als Beziehungsersatz. Als ich noch in einer
                    Beziehung lebte, gebrauchte ich meine Fantasie und dachte
                    zumeist an meine Freundin.{' '}
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Das kann ich verstehen. Ich bin ein Geruchsmensch. Deshalb
                    benutze ich häufig Utensilien ehemaliger Beziehungen zum
                    Onanieren: Slips, Foulards oder alte Socken von
                    Ex-Freundinnen. Über die Jahre riechen sie zwar nicht mehr
                    nach ihnen, doch der Geruch lebt in meiner Erinnerung
                    weiter. Ich habe bei einer Trennung auch schon um ein
                    Abschiedsgeschenk gebeten.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Ich denke beim Onanieren eher an die Zukunft denn an die
                    Vergangenheit. Ich stelle mir meistens Frauen vor, die ich
                    kennen gelernt habe und die ich begehre. Nicht immer erfüllt
                    sich der Traum, manchmal aber schon.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Warst du auch schon enttäuscht, weil die Realität schlechter
                    war als die Vorstellung?
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>Vielleicht nicht schlechter, aber anders.</p>
                </Answer>
              </Question>

              <Question
                q='Wie reagiert ihr auf Pornos?'
                classes='ui small blue header'
              >
                <Answer who='Nicolas'>
                  <p>Habe ich zu viel geschaut, bin ich wie abgestumpft.</p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Ich kenne das auch, ich habe eine Zeit lang zu viel
                    geschaut. Dann hast du wieder Sex, und du musst dich wieder
                    darauf einlassen. Das ist nicht immer einfach, denn du
                    suchst das Geile aus den Pornos, gleichzeitig willst du das,
                    was dich mit der Frau verbindet.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Das ist der typische Gedanke über Pornos und ihre Folgen.
                    Ich hatte das nicht. Es gab Phasen, in denen ich sehr viel
                    geschaut habe, doch es hat den realen Sex nie
                    unbefriedigender gemacht.
                  </p>
                </Answer>
              </Question>

              <Question q='Was törnt euch an?' classes='ui small blue header'>
                <Answer who='Beat'>
                  <p>
                    Wenn die Frau kommt. Das ist für mich das Grösste, nichts
                    macht mich geiler.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>Das ist bei mir gleich.</p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Bei mir ist es das, was kurz davor passiert. Es gibt nichts,
                    das mich mehr anmacht, als die Erregung einer Frau. Das
                    Problem: Sobald ich spüre, dass die Frau vor dem Orgasmus
                    steht, kommt es mir selbst.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Welche Fantasien habt ihr?'
                classes='ui small blue header'
              >
                <Answer who='Pascal'>
                  <p>
                    Ich finde Dreiergeschichten interessant – in allen
                    Konstellationen. Ich würde auch einmal gerne an eine
                    Sexparty gehen, die völlige Ungezwungenheit reizt mich.
                    Alles kann, nichts muss.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Einander Geschichten erzählen macht mich heiss. Ich habe
                    auch die Dreierfantasie, aber eher mit zwei Männern und
                    einer Frau. Es reizt mich nicht nur, zuzuschauen, wie er in
                    sie nimmt, sondern ich möchte auch ihn anfassen.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Das habe ich erlebt. Beide Geschlechter gleichzeitig
                    berühren ist extrem scharf.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Ich kann das verstehen, könnte aber selbst nicht einmal
                    einen Mann küssen. Auch Dreiergeschichten wären nichts für
                    mich, das würde mich überfordern. Überhaupt sind es mehr
                    Alltagssituationen, die bei mir Fantasien auslösen. Beim
                    Bezahlen an einer Kasse zum Beispiel. Früher hatte ich
                    Fantasien mit älteren Frauen, heute habe ich Fantasien mit
                    sehr jungen Frauen.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Du bist nicht der Einzige, der sich etwas vorstellt mit
                    einer ganz jungen Frau. Diese Reinheit zieht auch mich an.
                    In meinen Fantasien ist vor allem die Frau an sich präsent,
                    ihre intimen Körperstellen. Ihre Unterarme, der Fleck hinter
                    den Ohren, ihr Nacken, die Oberschenkelinnenseiten.
                    Achselhöhlen sind unglaublich sexy.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Die Faszination für den Dreier kenne ich, sie ist aber
                    nichts für mich. Ich finde es spannend, wenn die Frau sich
                    schöne Kleider anzieht, wenn sie spricht beim Sex. Nicht im
                    Sinn von Dirty Talk, sie soll eher übertreiben, vielleicht
                    auch mal Hochdeutsch reden. Das törnt mich an.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Könnt ihr eure Fantasien aussprechen?'
                classes='ui small blue header'
              >
                {' '}
                <Answer who='Silvan'>
                  <p>
                    Ich glaube, es ist ein Herantasten. Man beginnt mit kleinen
                    Dingen. Um seine Fantasien aussprechen zu können, braucht es
                    wohl schon eine entwickelte Sexualität. Dann kann man auch
                    über abwegige Sachen diskutieren.
                  </p>
                </Answer>
                <Answer who='Nicolas'>
                  <p>
                    Als junger Mann konnte ich meine Sexualität nicht
                    formulieren. Heute kann ichs.
                  </p>
                </Answer>
                <Answer who='Pascal'>
                  <p>
                    Ich finde das mega wichtig, dass auch das Thema Sex in einer
                    Beziehung entspannt ist, dass man auch perverse Gedanken
                    äussern kann. Das kann ich mit meiner Frau.
                  </p>
                </Answer>
                <Answer who='Beat'>
                  <p>
                    Ich funktioniere da etwas anders, ich spreche nicht auf so
                    abwegige Sachen an. Darum muss ich wohl weniger sprechen. Es
                    sind die alltäglichen Dinge, die mich scharfmachen. Hat sie
                    lange Beine, ihre langen Haare, untenrum nichts an, oben ein
                    flauschiger Pulli, solche Dinge. Es sind einfache Sachen,
                    und die spreche ich dann schon an.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Gibt es etwas, das ihr neben der Norm geil findet?'
                classes='ui small blue header'
              >
                {' '}
                <Answer who='Nino'>
                  <p>
                    Eine Frau hat mir einfach einmal mit Schwung ihren Finger in
                    den Arsch gesteckt. Unangekündigt. Es war das erste Mal, ich
                    war etwa 36, es war krass geil.
                  </p>
                </Answer>
                <Answer who='Pascal'>
                  <p>Ich mag das auch.</p>
                </Answer>
                <Answer who='Nicolas'>
                  <p>
                    Ich finde es eher schwierig. Eine hat es mit mir mal
                    probiert, ebenfalls unangekündigt. Ich so: eher nicht.
                  </p>
                </Answer>
                <Answer who='Beat'>
                  <p>
                    Ich habe mal bekifft eine seltsame Lust verspürt und mir
                    beim Anus rumgespielt. Doch das war nichts für mich.
                  </p>
                </Answer>
                <Answer who='Nino'>
                  <p>
                    Vor knapp einem Jahr war ich in einer Schwulensauna, ein
                    Kollege hat mich mitgeschleppt. Ein Mann kam auf mich zu,
                    nahm mir das Tuch weg und hat meinen Schwanz in den Mund
                    genommen. Der Typ hat so gut geblasen, dass ich steif
                    geworden bin. Das hat mich sehr verwirrt.
                  </p>
                </Answer>
                <Answer who='Silvan'>
                  <p>
                    Das verstehe ich eben nicht, die Frage nach Homo oder Bi ist
                    doch nicht wichtig. Ich war mal mit einem Mann im Bett, wir
                    haben uns gegenseitig eins geblasen, ich war einfach
                    neugierig, obwohl ich gewöhnlich auf Frauen stehe. Wenn es
                    geil ist, ist es eben geil – das ändert doch nichts an
                    deinem Selbstbild. Es ist schade, dass wir heute so
                    funktionieren. Das ist eine gesellschaftliche Sache, die uns
                    aufgedrückt wurde.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Gibt es Dinge, die euch abtörnen?'
                classes='ui small blue header'
              >
                <Answer who='Beat'>
                  <p>
                    Ich mag es nicht, wenn mich eine Frau auf Teufel komm raus
                    scharfmachen will. Etwa mit Worten, die aufgesetzt wirken,
                    wie in einem billigen Pornofilm. Ich mag es auch nicht, wenn
                    sie mir den Rücken blutig kratzt – oder orale Befriedigung
                    mit Zahneinsatz.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Mich frustriert es, wenn die Frau keine Signale aussendet.
                    Wenn sie nichts sagt, passiv ist. Vermutlich ist es dann
                    einfach ein Zeichen, dass es ihr nicht gefällt.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Ja, Passivität ist sehr abtörnend. Ich mag es auch nicht,
                    wenn eine Frau mir die Eier leckt.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Wenn die Frau unbedingt die Oberhand behalten will. Ich
                    machte auch schon den Fehler, mit Frauen nach Hause zu
                    gehen, die stark betrunken waren. Es war kein
                    Gemeinschaftsspiel mehr.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Habt ihr auch Phasen des bewussten Verzichts?'
                classes='ui small blue header'
              >
                <Answer who='Nicolas'>
                  <p>
                    Wenn ich in einer Beziehung bin, dann versuche ich, nicht zu
                    masturbieren. Ich möchte die Lust für meine Partnerin
                    aufbewahren. Als Single masturbiere ich häufiger vor dem
                    Einschlafen. Noch häufiger spreche ich zu Gott. Das ist für
                    mich Entspannung auf einer höheren Ebene. Das mache ich dann
                    so vier oder fünf Tage und dann onaniere ich wieder. Das
                    stimmt für mich so.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Interessant, mir geht es ähnlich. Ich bin zwar nicht
                    religiös, aber es gibt Phasen, in denen ich meditiere. Dann
                    tritt die Lust bei mir in den Hintergrund. Die Lust wird
                    gewissermassen durch das Spirituelle ersetzt.{' '}
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Enthaltsamkeit praktiziere ich, wenn ich weiss, dass ich
                    morgen rennen gehe. Denn ich merke, dass der Körper mehr
                    Energie hat, wenn ich nicht masturbiere. Aber: Wenn ich
                    kreativ sein muss, dann mache ich es mir oder habe Sex.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Momentan erlebe ich eine Phase mit wenig Sex. Meine Frau ist
                    schwanger, und es ist gerade schwierig. Auch wenn wir eine
                    offene Beziehung führen, haben wir nun abgemacht, dass wir
                    das für eine Weile aussetzen.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Erektionsprobleme – kennt ihr das?'
                classes='ui small blue header'
              >
                <Answer who='Nino'>
                  <p>
                    Oh ja. Wenn zu viel Alkohol im Spiel ist, oder du zu viel im
                    Kopf hast. Wenn eine geile Frau neben dir liegt und es nicht
                    klappt, dann kannst du dich totschlagen. Doch das ist dann
                    halt so, ich entschuldige mich auch nicht.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Das habe ich auch schon erlebt. Klar kommt ein Gefühl der
                    Scham auf, doch der nächste Tag kommt ja. Das ist völlig
                    normal. Zu viel sprechen bringt da gar nichts.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Das kenne ich. Der Druck, einen richtig Harten zu haben,
                    macht dann vielleicht grad eben einen Halbharten. In einer
                    Beziehung kommen dann die grossen Fragen, es wird sehr
                    kompliziert, weil viel hineininterpretiert wird. Bin ich
                    nicht mehr sexy? Genüge ich nicht mehr? Doch ich habe
                    erfahren, dass Sexualität auch mit einem Halbsteifen gelebt
                    werden kann. Ich würde unterscheiden zwischen Erektion und
                    Erregung. Manchmal bist du pickelhart, aber nicht erregt –
                    und manchmal umgekehrt. Es gibt einfach Situationen, die
                    kannst du nicht kontrollieren.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Ich kenne diese Probleme nicht. Ich habe aber auch schon
                    onaniert und bin gekommen, obwohl ich nicht hart war.
                    Stressonanie. Das hat mich sehr verwirrt. Doch es gibt
                    andere Sachen, an denen ich mich mehr aufreibe. Körperliche
                    Sachen, Waschbrettbauch, Penislänge. Du wirst durch Pornos
                    halt damit konfrontiert. Du denkst: Wie wäre es, einen
                    Grösseren zu haben.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Den Gedanken gibts, doch er war bei mir nie problembehaftet.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Ich glaube, bis zu einem gewissen Alter ist die Länge schon
                    ein Thema, aber wenn du genug Sex gehabt hast, weisst du,
                    dass das sekundär ist.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Mit der Zeit weisst du, dass es vor allem auf die Technik
                    mit der Partnerin ankommt und nicht auf die Schwanzlänge.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Bei mir ist weniger die Grösse ein Thema als das
                    Zu-schnell-Kommen. Wenn du so erregt bist, dass du bereits
                    nach Minuten kommen könntest. Du bist drin und kannst es
                    kaum kontrollieren. Das ist ein Scheiss.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>Ich denke da immer an einen Abfallkübel, das hilft.</p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Ich habe auch schon probiert, das Kommen mit einem
                    bestimmten Muskel zu kontrollieren, ist aber schwierig.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Was ich gut finde, sind zwei Bier. Das macht mich etwas
                    weniger sensibel, dann spüre ich etwas weniger. Zu viel Bier
                    ist natürlich wieder schlecht. Mit 30 habe ich mal MDMA
                    probiert. Ich habe mich gefühlt, als ob ich im Eiswasser
                    gesessen hätte.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>Oh! Sex mit MDMA ist bombastisch.</p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Sex mit Drogen hab ich eine Zeit lang auch gemacht. Es war
                    speziell gut. Aber ich habe auch schon speziell dreckige
                    Erfahrungen gemacht. Drogen bringen uns an einen Ort, bei
                    dem wir nicht mehr wir selbst sind. Dann verlierst du das
                    Gefühl und die Connection für den Menschen. Da mir dies
                    gerade beim Sex sehr wichtig ist, mache ich das nicht mehr.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Mit Drogen wirst du hemmungsloser, du kommst auf einem neuen
                    Level.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Was ist das neue Level? Ist es gefühlsbetonter oder
                    hemmungsloser? Oder einfach mehr Sex? Mir ist Ersteres
                    wichtig. Ich habe Freunde, die haben 400 Frauen gehabt und
                    die wildesten Sachen ausprobiert – heute sind sie innerlich
                    tot. Sex als Sport kann ich nicht empfehlen.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Ich unter Umständen schon, weil du dich immer weiter pushst
                    und immer höhere Level erreichst. Irgendwann aber wirst du
                    abgestumpft. Aber das allererste Mal Sex mit Ecstasy war –
                    ich kann es nicht beschreiben – Feuerwerk, Meeresrauschen
                    und Windstösse zusammen, mit Erdbeben und Atombombe, alles
                    gleichzeitig.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Das war bei mir nicht so. Ohne Drogeneinfluss gefällt es mir
                    irgendwie besser.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Bezahlen für Sex – für euch eine Option?'
                classes='ui small blue header'
              >
                <Answer who='Nino'>
                  <p>
                    Ich mache es regelmässig und gehe wohl alle zwei Wochen zu
                    der stets gleichen Frau. Ich bin recht zufrieden. Mit ihr
                    erlebe ich eine kleine Fantasie. Es hat etwas von einer
                    Beziehung, obwohl ich weiss, es ist eine bezahlte Freundin.
                  </p>
                </Answer>

                <Answer who='Beat'>
                  <p>
                    Ich habe es einmal gemacht, ich war recht betrunken, es war
                    beim Limmatquai, eine Frau hat mich in ihren Wohnwagen
                    genommen, es hat nach Vanille gerochen, es war absurd. Neben
                    uns im Wohnwagen lag noch ein anderer Typ mit einer anderen
                    Nutte. Der Sex war dann derart mechanisch, sie war oben, ich
                    kam nicht, es war richtig schlecht. Ich habe es arg bereut
                    und hatte am nächsten Tag ein schlechtes Gewissen.
                  </p>
                </Answer>

                <Answer who='Nicolas'>
                  <p>
                    Ich habe es einmal mit Freunden probiert in Amsterdam, als
                    ich noch jung war. Wir gingen rein, haben es gemacht, und
                    das Haus wieder verlassen. Da sah ich eine Schlange von
                    Männern vor dem Puff. Es war wie eine Fabrik. Das hat mir
                    gereicht, ich habe es niemals wiederholt.
                  </p>
                </Answer>

                <Answer who='Silvan'>
                  <p>
                    Ich würde an sich gerne einmal mit einer Prostituierten
                    schlafen, so rein aus Neugierde. Doch Prostitution hat
                    praktisch immer mit Ausbeutung zu tun, darum kommt es für
                    mich in der Realität nicht infrage.
                  </p>
                </Answer>

                <Answer who='Pascal'>
                  <p>
                    Ich war noch nie bei einer Prostituierten, mich törnts
                    extrem ab.
                  </p>
                </Answer>

                <Answer who='Nino'>
                  <p>
                    Ich kenne den Gedanken der Ausbeutung. Die Frau, die ich
                    regelmässig besuche, geht anschaffen, um zu überleben. Sie
                    hat Kinder. Ich habe mit ihr darüber gesprochen. Ich kann
                    ihr in die Augen schauen, und ich glaube, sie hat auch Spass
                    mit mir, so gehen wir auch mal nur tanzen. Nun, ich fühle
                    mich nicht als Ausbeuter.
                  </p>
                </Answer>
              </Question>

              <Question
                q='Offene Beziehung, ein Thema?'
                classes='ui small blue header'
              >
                {' '}
                <Answer who='Nino'>
                  <p>Meine Erfahrung sagt mir: Das geht einfach nicht.</p>
                </Answer>
                <Answer who='Silvan'>
                  <p>
                    Ich kann es mir vom Konzept her vorstellen und finde es
                    eigentlich logisch, das zu machen. Zugleich macht es mir
                    Angst. Sex ist eben nicht nur Sex, sondern hat auch viel mit
                    der Anziehung darüber hinaus zu tun. Darum habe ich es noch
                    nie probiert.
                  </p>
                </Answer>
                <Answer who='Nicolas'>
                  <p>
                    Mein Ziel ist es, das Leben lang verliebt zu bleiben. Und
                    ich will das nur mit einer Person sein. Darum ist das nichts
                    für mich.
                  </p>
                </Answer>
                <Answer who='Beat'>
                  <p>
                    Meine letzte Freundin hatte gerne Freiheiten, sie hat sich
                    viel mit Männern zum Bier getroffen, das war okay für mich.
                    Ich war mir sicher, dass sie gerne fremdgehen würde.
                    Vielleicht auch darum kann ich es mir wohl nicht vorstellen.
                    Ich habe Angst, dass sie dort etwas bekommt, was sie bei mir
                    nicht hat. Ich hätte so Freude, wenn ich das könnte, aber es
                    geht einfach nicht.
                  </p>
                </Answer>
                <Answer who='Pascal'>
                  <p>
                    Es ist ein Prozess. Ich und meine Frau haben beschlossen,
                    dass wir lange zusammen sein wollen, dass wir uns nicht
                    betrügen, und dass wir immer ehrlich zueinander sind – also
                    haben wir die Beziehung geöffnet. Es wurde dadurch
                    entspannter, aber zugleich auch komplizierter. Wir haben
                    Grundregeln abgemacht: Safer Sex, nicht im Freundeskreis
                    oder bei der Arbeit. Am Morgen um sieben zu Hause. Wir
                    erzählen uns alles. Das braucht Zeit. Wir reden stundenlang
                    über Eifersucht und wie sie entsteht. Das schafft aber auch
                    eine wunderbare Nähe.
                  </p>
                </Answer>
                <Answer who='Beat'>
                  <p>
                    Das war gerade das Problem bei meiner letzten Beziehung, ich
                    fragte sie: Hast du mich betrogen? Sie konnte keine Antwort
                    geben. Erst dann merkte ich, wir können gar nicht
                    miteinander reden. Wir hatten nie derart tiefe Gespräche,
                    wie du sie hast. Darum denke ich, falls ich mit meiner
                    nächsten Freundin gut sprechen kann, wäre vielleicht auch
                    eine offene Beziehung zumindest eine Überlegung wert.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />
        </main>

        <div className='container'>
          <FollowUp />
        </div>
        <Footer
          articleId={ARTICLE_ID}
          credits={[
            ['Text', 'Martin Sturzenegger, Christian Zürcher'],
            [
              'Digitales Konzept, Umsetzung & Illustration',
              'Kaspar Manz, Marc Brupbacher'
            ],
            ['Fotos', 'Stuart Sandford, Albert Pocej']
          ]}
          hideUserFeedback
        />

        {/* <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td>Digitales Konzept, Umsetzung & Illustration:</td>
                    <td>Interaktiv-Team</td>
                  </tr>
                  <tr>
                    <td>Fotografien Männer</td>
                    <td>Stuart Sandford<br />
                      <a href='http://www.stuartsandford.co.uk/Cumfaces-2007'
                         target='_blank'
                         style={{color: 'lightblue'}}>Cumfaces 2007
                        <i className='external link icon'/> </a>
                    </td>
                  </tr>
                  <tr>
                    <td>Fotografien Frauen</td>
                    <td>Albert Pocej<br />
                      <a href='http://blog.tagesanzeiger.ch/zoom/index.php/80208/orgasmus/'
                         target='_top'
                         style={{color: 'lightblue'}}>Weitere Fotografien dieser
                        Serie auf <em>Zoom</em>
                        <i className='external link icon'/> </a>
                    </td>
                  </tr>
                  <tr className='desktop-only'>
                    <td colSpan='2'><CopyrightNotice inverted/></td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div className='column'>

                <table className='ui definition inverted very basic table'>
                  <tbody>
                  <tr>
                    <td><i className='comments icon'/></td>
                    <td>
                      <div className='content'>
                        <div className='header'> Haben Sie Anmerkungen oder
                          einen Fehler entdeckt?
                        </div>
                        <p>
                          <span>Wir freuen uns über Ihre </span>
                          <a href='mailto:interaktiv@tages-anzeiger.ch?subject=Fünf Männer über Sex'>Nachricht</a>
                          <span>.</span>
                        </p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan='2' className='footer-sharing'>
                      <div className='spacer'>&nbsp;</div>
                      <StandaloneShareButtons articleID='10109868'/> <Tracking
                      articleId='10109868'/>

                      <Waypoint scrollableAncestor={window}
                                onEnter={(event) => {
                                  if (event.previousPosition ===
                                    'below') {
                                    window.dataLayer =
                                      window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'pageBottom'
                                      }
                                    )
                                  }
                                }}/>
                      <div className='spacer'>&nbsp;</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div> */}
      </div>
    )
  }
}

AppComponent.defaultProps = {}

// /**
//  * @fileOverview The main entry point to your standalone. Start editing here.
//  */

// import React from 'react'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
// import './styles.scss'
// import { TypescriptComponent } from 'components/typescriptExample'
// import { Masthead } from '@ta-interaktiv/react-masthead'
// import { Footer } from '@ta-interaktiv/react-footer'
// import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// // TODO Set the correct article ID here
// const ARTICLE_ID = '00000000'

// export function AppComponent() {
//   return (
//     <div className='index'>
//       <Masthead articleId={ARTICLE_ID} />
//       <ThemeSwitch />

//       <header className='ui vertical  very fitted  segment'>
//         <div className='ui container'>
//           <div className='ui header'>
//             <h1>Lorem ipsum dolor sit amet, consectetuer adipiscing elit</h1>
//             <h2>
//               Nullam dictum felis eu pede mollis pretium. Integer tincidunt.
//               Cras dapibus. Vivamus elementum semper nisi. Donec quam felis,
//               ultricies nec, pellentesque eu, pretium quis, sem.
//             </h2>
//           </div>
//         </div>
//       </header>

//       <div className='ui vertical segment'>
//         <div className='ui text container'>
//           <div className='ta metainfo'>
//             <div className='ta author'>Hans Muster</div>
//             <div className='ta updated'>Aktualisiert am 31. XXXXXXX 2020</div>
//           </div>
//           <div className='ta text'>
//             Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque
//             penatibus et magnis dis parturient montes, nascetur ridiculus mus.
//             Nulla consequat massa quis enim. Donec pede justo, fringilla vel,
//             aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut,
//             imperdiet a, venenatis vitae, justo. Aenean vulputate eleifend
//             tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend
//             ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a,
//             tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque
//             rutrum.
//           </div>
//         </div>
//       </div>

//       <Footer articleId={ARTICLE_ID} credits={[['Credits', 'go here']]} />
//     </div>
//   )
// }
